<div class="dialog-wrapper">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        <h1 matDialogTitle>{{confirmTitle}}</h1>
        <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content *ngIf="showConfirmation">
        <span>
            {{confirmMessage}}
        </span>
    </div>

    <div mat-dialog-content *ngIf="!showConfirmation">
        <ng-container *ngComponentOutlet="component"></ng-container>
    </div>

    <div mat-dialog-actions class="pt-24" *ngIf="showConfirmation">
        <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">Confirm</button>
        <button mat-button (click)="dialogRef.close(false)">Cancel</button>
    </div>
</div>

